/**
 * Preguntas sugeridas del asistente de Talent Acquisition. Las usa la burbuja del
 * FAB (las 3 primeras), la subtab Asistente y el chat vacío.
 *
 * Están en el i18n, no fijas en castellano: desde el 27/09/2026 el agente contesta
 * en el idioma de quien escribe, y ofrecerle preguntas en otro idioma era pedirle
 * a la persona que arranque en un idioma y le respondan en otro.
 *
 * Dos juegos, porque el universo no es el mismo: en la sección de TA el agente ve
 * la base entera; en el apartado de intake, solo las búsquedas de quien pregunta.
 */
import { useTranslation } from 'react-i18next';

export type TaAssistantScope = 'metrics' | 'intake';

const CLAVES: Record<TaAssistantScope, string> = {
  metrics: 'talent_acquisition.assistant_tab.questions',
  intake: 'talent_acquisition.assistant_tab.mine_questions',
};

export function useTaSuggestedQuestions(scope: TaAssistantScope = 'metrics'): string[] {
  const { t } = useTranslation();
  const qs = t(CLAVES[scope], { returnObjects: true });
  return Array.isArray(qs) ? (qs as string[]) : [];
}
